import { create } from "zustand";
import { RenderPropComponentProps } from "./form";
import * as yup from "yup";

// Zustand store for form state
export interface FormHelperState {
    readOnly: boolean;
    toggleReadOnly: () => void;
    horizontalForm: boolean;
    setHorizontalForm: (value: boolean) => void;
    setReadOnly: (value: boolean) => void;
    initialize: <T extends yup.AnyObject>(props: RenderPropComponentProps<T>) => void;
}

export const useFormHelperStore = create<FormHelperState>((set) => ({
    readOnly: false,
    toggleReadOnly: () => set((state) => ({ readOnly: !state.readOnly })),
    setReadOnly: (value: boolean) => set({ readOnly: value }),
    horizontalForm: false,
    setHorizontalForm: (value: boolean) => set({ horizontalForm: value }),
    initialize: <T extends yup.AnyObject>(props : RenderPropComponentProps<T>) => set({ readOnly: props.readOnly, horizontalForm: props.horizontalForm }),
}));
